import React from 'react';
import styled from 'styled-components';
import { useClientConfig } from '../../contexts/ClientConfigContext';

/** Shown when the API is configured to skip IPFS uploads because write is unavailable. */
export const SKIP_IPFS_UPLOADS_IF_WRITE_UNAVAILABLE_MESSAGE =
  'IPFS write is not available: uploads are not sent to the IPFS API. You can continue tokenizing and minting for testing; documents use local hash placeholders only (not pinned to IPFS).';

const Bar = styled.div`
  width: 100%;
  padding: 0.55rem 1rem;
  background: linear-gradient(90deg, rgba(180, 120, 0, 0.35) 0%, rgba(120, 80, 0, 0.25) 100%);
  border-bottom: 1px solid rgba(255, 200, 80, 0.35);
  color: #ffe8b8;
  font-size: 0.82rem;
  line-height: 1.45;
  text-align: center;
`;

export default function IpfsSkipUploadsIfWriteUnavailableBanner() {
  const { skipIpfsUploadsIfWriteUnavailable } = useClientConfig();
  if (!skipIpfsUploadsIfWriteUnavailable) return null;
  return (
    <Bar role="status">
      {SKIP_IPFS_UPLOADS_IF_WRITE_UNAVAILABLE_MESSAGE}
    </Bar>
  );
}
